<template>
  <div :id="location">
    <div v-for="category in categories" :key="category.id">
      <p class="mt-5">{{ category.title }}</p>
      <div v-for="topic in category.topics" :key="topic.id">
        <b-button
          :href="'/support/' + getCategory(topic.category) + '/' + topic.id"
          class="py-0"
          style="display: inline; text-decoration: underline; color: #0064C1;"
          variant="link"
          >{{ topic.title }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'HelpTopicsCategories',
    props: {
      loading: Boolean,
    },
    data() {
      return {
        categories: [],
        customCategories: {
          'custom-application-access': 'application-access',
        },
        location: this.$route.name,
      };
    },
    created() {
      this.getCategories();
    },
    methods: {
      async getCategories() {
        this.$emit('update:loading', true);
        let category =
          this.location in this.customCategories
            ? this.customCategories[this.location]
            : this.location;
        let locationRequest = axios.get(`/api/get-help-topics`, {
          params: { category: category },
        });
        let generalRequest = axios.get(`/api/get-help-topics`, {
          params: { category: 'GENERAL' },
        });
        await axios
          .all([locationRequest, generalRequest])
          .then(
            axios.spread((...responses) => {
              const locationCategory = responses[0];
              const generalCategory = responses[1];
              if (locationCategory.status !== 204) {
                this.addCategory(locationCategory.data['items']);
              }
              if (generalCategory.status !== 204) {
                this.addCategory(generalCategory.data['items']);
              }
            }),
          )
          .catch(errors => {
            console.error(errors);
            alert(`Server is not responding, please try again later`);
          });
        this.$emit('update:loading', false);
      },
      addCategory(category) {
        this.categories.push({
          topics: category.sort(
            (firstItem, secondItem) => secondItem.priority - firstItem.priority,
          ),
          title: category[0]['categoryTitle'],
        });
      },
      getCategory(category) {
        if (category in this.customCategories) {
          return this.customCategories[category];
        }
        return category;
      },
    },
  };
</script>
